import { useTranslation } from 'react-i18next';
import { Row } from '@tanstack/react-table';
import Button from 'components/button/Button';
import { RentalConditions } from 'models/RentalCondition';
import PropertyEditActionWrapper from 'pages/property/common/PropertyEditActionWrapper';
import usePropertySettingsInitData from 'pages/property/usePropertySettingsInitData';
import { PropertyBusinessType } from 'models/Properties';
import useEditRentalConditions from '../modals/useEditRentalConditions';

const ActionsCell = ({ row }: { row: Row<RentalConditions> }) => {
  const { t } = useTranslation();
  const { property } = usePropertySettingsInitData();

  const { openEditModal } = useEditRentalConditions({
    rentalConditions: row.original,
  });

  const isUnitType = property?.businessType === PropertyBusinessType.UNIT_TYPE;

  return (
    <PropertyEditActionWrapper tooltipId="row-edit-rental-conditions-button-tooltip">
      <Button
        bsStyle="link"
        data-testid="row-edit-rental-conditions-button"
        disabled={isUnitType}
        onClick={openEditModal}
      >
        {t('common.edit')}
      </Button>
    </PropertyEditActionWrapper>
  );
};

export default ActionsCell;
